module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholders":{"email":"E-mail","password":"Password"},"cta":"Sign-in my account"}}')
  delete Component.options._Ctor
}
